export const CIPO_V1ResourcesEN: CIPO_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  type: {
    EvdLabel: "Note",
    Name: "type",
    Placeholder:
      "Enter: Regular, extraordinary, general, weekly, monthly, yearly...",
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  errors: {
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
};

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface CIPO_V1ResourcesBSInterface {
  labelDone: string;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: {
    recordAlreadyExists: string;
  };
}
